import { Fragment } from 'react';

import useNTGroupMemberIdForm from './UseNTGroupMemberIdForm';

import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import PrimaryButton from '@usas/ui-web/components/buttons/PrimaryButton';
import SearchMemberWithLscPopup from '@usas/ui-web/components/searches/searchMember/SearchMemberWithLscPopup';

import { LOADING_MSG } from '@usas/ui-web/utils/Constants';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const NTGroupMemberIdForm = ({ primaryButtonText = 'Add Member', onSubmitFormCallback }) => {
  const {
    isLoading,
    formState,
    errorState,
    handleSubmit,
    setFormData,
    onFormValueChanged
  } = useNTGroupMemberIdForm(onSubmitFormCallback);

  return (
    <Fragment>
      <form onSubmit={handleSubmit} noValidate>
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 col-sm-6 col-md-4">
            <SearchMemberWithLscPopup
              formState={formState}
              errorState={errorState}
              setFormData={setFormData}
              onFormValueChanged={onFormValueChanged}
              isCurrentOrgUnitMember={true} />
          </div>
        </div>
        {errorState.apiError &&
          <div className="row">
            <div className="col-xs-12 usas-extra-top-margin">
              <p className={global.ErrorMessage}>{errorState.apiError}</p>
            </div>
          </div>
        }
        <div className="row usas-extra-top-margin usas-extra-bottom-margin">
          <div className="col-xs-12 usas-extra-top-margin">
            <PrimaryButton type="submit">{primaryButtonText}</PrimaryButton>
          </div>
        </div>
      </form>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={LOADING_MSG}
        displayPopUp={isLoading} />
    </Fragment>
  );
};

export default NTGroupMemberIdForm;